(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Details_2-0_Module_2"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
            $('.dynamic-characteristics-left_content-layout').click(function() {
                // 获取当前点击的标题和内容
                const currentTitle = $(this);
                const currentContent = currentTitle.next('.drop-down_display');

                // 隐藏所有内容
                $('.dynamic-characteristics-left_content-layout').removeClass('active');
                $('.drop-down_display').slideUp();

                // 如果当前内容已经展开，则隐藏它
                if (currentContent.is(':visible')) {
                    currentContent.slideUp();
                 currentTitle.removeClass('active');
                } else {
                    // 否则展开当前内容
                  currentTitle.addClass('active');
                    currentContent.slideDown();
                }
            });
          $('.dynamic-characteristics_title').on('click', function () {
             $(this).addClass('active').siblings().removeClass('active');
              var index=$(this).index();
            $('.dynamic-characteristics_title').eq(index).addClass('active').siblings().removeClass('active');
             $('.dynamic-characteristics-items_list .dynamic-characteristics_layout').eq(index).addClass('active').siblings().removeClass('active')
          })
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Details_2-0_Module_3"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $('.characteristics-left_content-layout').click(function() {
        // 获取当前点击的标题和内容
        const currentTitle = $(this);
        const currentContent = currentTitle.next('.dynamic-characteristics_drop-down_display');

        // 隐藏所有内容
        $('.characteristics-left_content-layout').removeClass('active');
        $('.dynamic-characteristics_drop-down_display').slideUp();

        // 如果当前内容已经展开，则隐藏它
        if (currentContent.is(':visible')) {
            currentContent.slideUp();
         currentTitle.removeClass('active');
        } else {
            // 否则展开当前内容
          currentTitle.addClass('active');
            currentContent.slideDown();
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Rich-Text-Framework"]) return;
  try {
    
  $(document).ready(function() {
  $('.flexified-child').mouseenter(function() {
    var itemId = $(this).attr('data-id');
    $('.login-'+itemId).css('display','flex')
  });
    $('.flexified-child').mouseleave(function() {
    var itemId = $(this).attr('data-id');
    $('.login-'+itemId).hide()
  });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athlete_content2"]) return;
  try {
    
      const elements = $('.athletes__container');
    $(elements).click(function () {
      var index = $(elements).index(this)
      // alert($(elements).eq(index).hasClass('active'))
      if ($(elements).eq(index).hasClass('active')) {
        $(elements).eq(index).addClass('blur')
        $(elements).eq(index).removeClass('active')
      } else {
        $(elements).eq(index).addClass('active')
        $(elements).eq(index).removeClass('blur')
      }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swiper_carousel"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('#swiper_02',{
      pagination: {
    el: '.swiper-pagination',
    bulletElement : 'li',
        clickable :true,
  }
    });

  } catch(e) { console.error(e); }
})();
})();
